import csbGear from '@/assets/svgs/commanderspellbook-gear.svg'
import { CardLink } from '@/components/common/Card'
import { LinkOutbound } from '@/components/common/Link'
import { isNonEmptyString } from '@/utils/commonUtil'
import { buildRec } from '@/utils/recUtil'

import styles from './CSBEmbed.module.scss'

type Props = {
  id: string
  url: string
}

const parseList = (value: string | null): string[] => {
  try {
    const parsed = JSON.parse(value || '[]')
    return Array.isArray(parsed) ? parsed.filter(isNonEmptyString) : []
  } catch {
    return []
  }
}

export const CSBEmbed = ({ id, url }: Props) => {
  const params = new URLSearchParams(url)
  const color = params.get('color')
  const extraRequirementCount = parseInt(params.get('extraRequirementCount') || '')
  const produces = parseList(params.get('produces'))
  const requires = parseList(params.get('requires'))
  const uses = parseList(params.get('uses'))

  const extraRequirementString =
    extraRequirementCount === 1 ? '+1 other prerequisite' : `+${extraRequirementCount} other prerequisites`
  const href = `https://commanderspellbook.com/combo/${id}`

  return (
    <div className={styles.container}>
      <LinkOutbound href={href} utm={{ medium: 'article' }}>
        <div className={styles.colorId}>
          {color?.split('').map((c, i) => (
            <i className={`ms ms-${c.toLowerCase()} ms-cost ms-shadow`} key={`color-${i}`} />
          ))}
        </div>
      </LinkOutbound>
      <div className={styles.cardList}>
        {uses.map((cardName) => {
          const rec = buildRec({ name: cardName })

          return (
            <div key={`uses-${cardName}`}>
              <CardLink className={styles.link} placement='right' rec={rec}>
                {cardName}
              </CardLink>
            </div>
          )
        })}
        {requires.map((cardName) => (
          <div key={`requires-${cardName}`}>{cardName}</div>
        ))}
        {extraRequirementCount > 0 && (
          <LinkOutbound className={styles.extraRequirement} href={href} utm={{ medium: 'article' }}>
            {extraRequirementString}
          </LinkOutbound>
        )}
      </div>
      <ul className={styles.featureList}>
        {produces.map((feature) => (
          <li key={`produces-${feature}`}>
            <LinkOutbound className={styles.produces} href={href} utm={{ medium: 'article' }}>
              {feature}
            </LinkOutbound>
          </li>
        ))}
      </ul>
      <LinkOutbound href={href} utm={{ medium: 'article' }}>
        <div className={styles.logo}>
          <img alt='' decoding='async' height='30' loading='lazy' role='presentation' src={csbGear.src} width='30' />
          <span>Commander Spellbook</span>
        </div>
      </LinkOutbound>
    </div>
  )
}
